import Dashboard from "@/views/gekko/Dashboard";
import Costs from "@/views/gekko/Costs";
import Hours from "@/views/gekko/Hours";
import Bank from "@/views/gekko/Bank";
import Invoices from "@/views/gekko/Invoices";
import EditCost from "@/components/costs/EditCost";
import Contacts from "@/views/gekko/Contacts"
import Trips from "@/views/gekko/Trips";
import AddEditContact from "@/components/contacts/AddEditContact";
import AddEditProject from "@/components/contacts/AddEditProject";
import AddEditTrip from "@/components/trips/AddEditTrip";
import BalanceSheet from "@/views/gekko/BalanceSheet";
import CostTypesSettings from "@/views/settings/CostTypesSettings";
import AddEditItem from "@/components/balance_sheet/AddEditItem";
import FinancialReporting from "@/views/gekko/FinancialReporting";
import Documents from "@/views/gekko/Documents";
import AddEditDocument from "@/components/documents/AddEditDocument";
import ShareDocument from "@/components/documents/ShareDocument";
import Reports from "@/views/gekko/Reports";
import HoursReport from "@/views/gekko/HoursReport";
import TaxreportList from "@/views/gekko/TaxreportList";
import Taxreport from "@/views/gekko/Taxreport";

import invoicesRoutes from "./invoices/"

const routes = [
    { path: '/:language/dashboard', name: 'Dashboard', component: Dashboard, meta: { title: 'Dashboard' } },
    { path: '/:language/costs/', name: 'Costs', component: Costs, meta: { title: 'Costs' }, pathToRegexpOptions:{strict:true}, children: [
        { path: 'edit/:costId', component: EditCost, name: 'EditCost', meta: { title: 'Edit costs' }  },
        { path: 'add/', component: EditCost, name: 'AddCost', meta: { title: 'Add cost' }  },
    ] },
    { path: '/:language/hours/', name: 'Hours', component: Hours, meta: { title: 'Hours' }, pathToRegexpOptions:{ strict:true } },
    { path: '/:language/bank/', name: 'Bank', component: Bank, meta: { title: 'Bank' }, pathToRegexpOptions:{ strict:true } },

    {
      path: '/:language/invoices/',
      name: 'Invoices',
      meta: { title: 'Invoices' },
      component: Invoices,
      pathToRegexpOptions: { strict: true },
      children: [
        ...invoicesRoutes
      ] 
    },

    { path: '/:language/addressbook/', name: 'Contacts', component: Contacts, meta: { title: 'Contacts' }, pathToRegexpOptions: { strict: true }, children: [
      { path: 'contact/edit/:contactId', component: AddEditContact, name: 'EditContact', meta: { title: 'Edit contact' } },
      { path: 'contact/add/', component: AddEditContact, name: 'AddContact', meta: { title: 'Add contact' } },
      { path: 'project/edit/:contactId/:projectId', component: AddEditProject, name: 'EditProject', meta: { title: 'Edit project' } },
      { path: 'project/add/:contactId', component: AddEditProject, name: 'AddProject', meta: { title: 'Add project' } }
    ] },
    { path: '/:language/trips/', name: 'Trips', component: Trips, meta: { title: 'Trips' }, pathToRegexpOptions: {strict: true}, children: [
      { path: 'edit/:tripId', component: AddEditTrip, name: 'EditTrip', meta: { title: 'Edit trip' }},
      { path: 'add/', component: AddEditTrip, name: 'AddTrip', meta: { title: 'Add trip' }}
    ] },
    { path: '/:language/investments/', name: 'BalanceSheet', component: BalanceSheet, meta: { title: 'Balance Sheet Investments' }, pathToRegexpOptions:{ strict:true }, children: [
      { path: 'costtypes/', component: CostTypesSettings, name: 'CostTypes', meta: { title: 'Cost types' } },
      { path: 'editcost/:costId', component: EditCost, name: 'BalanceSheetEditCost', meta: { title: 'Edit costs' } },
      { path: 'additem/', component: AddEditItem, name: 'AddItem', meta: { title: 'Add item' } },
      { path: 'edititem/:investmentId', component: AddEditItem, name: 'EditItem', meta: { title: 'Edit item' } }
    ] },
    { path: '/:language/financial-statements/', name: 'FinancialStatements', component: FinancialReporting, meta: { title: 'Financial Statements' }, pathToRegexpOptions:{ strict:true }, children: [] },
    { path: '/:language/documents/', name: 'Documents', component: Documents, meta: {title: 'Documents'}, pathToRegexpOptions: {strict: true}, children: [
      {path: 'edit/:documentId', component: AddEditDocument, name: 'EditDocument', meta: { title: 'Edit documents' }},
      {path: 'add/', component: AddEditDocument, name: 'AddDocument', meta: { title: 'Add document'}},
      {path: 'share/', component: ShareDocument, name: 'ShareDocument', meta: { title: 'Share Document'}}
    ]},
    { path: '/:language/reports/', name: 'Reports', component: Reports, meta: { title: 'Reports'}, pathToRegexpOptions: {strict: true}, children: [] },
    { path: '/:language/reports/hours/', component: HoursReport, name: 'HoursReport', meta: { title: 'Hours Report' }, pathToRegexpOptions: {strict: true}, children: []  },
    { path: "/:language/reports/vat/", component: TaxreportList, name: "TaxreportList", meta: { title: 'ReportsVAT' } },
    { path: "/:language/reports/vat/create/", component: Taxreport, name: "CreateTaxreport", meta: { title: 'Create report' } },
    { path: "/:language/reports/vat/view/:id", component: Taxreport, name: "ViewTaxreport", meta: { title: 'View report' } },
  ];

export default routes;
